import { FC } from 'react';
import { View } from '../../types';
import { MenuIcon, XIcon } from '../Icons';
import UserMenu from './UserMenu';

interface HeaderProps {
    isSidebarOpen: boolean;
    setIsSidebarOpen: (v: boolean) => void;
    currentView: View;
    onNavigate: (view: View, subView?: string) => void;
}

const viewTitles: { [key in View]: string } = {
    DASHBOARD: 'Панель управления',
    WAYBILLS: 'Путевые листы',
    DICTIONARIES: 'Справочники',
    WAREHOUSE: 'Склад',
    REPORTS: 'Отчеты',
    ADMIN: 'Настройки',
    ABOUT: 'О программе',
    USER_GUIDE: 'Руководство пользователя',
    ADMIN_GUIDE: 'Руководство администратора',
    DEVELOPER_GUIDE: 'Документация для разработчика',
    // BLANKS moved to WAYBILLS tab
    TESTING_GUIDE: 'Руководство для тестировщика',
    MEDICAL_REPORT: 'Журнал медосмотров',
    OWNER_PANEL: 'Панель Владельца',
};

export const Header: FC<HeaderProps> = ({
    isSidebarOpen,
    setIsSidebarOpen,
    currentView,
    onNavigate,
}) => {
    return (
        <header className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 border-b dark:border-gray-700 shadow-md">
            <div className="flex items-center gap-4">
                <button
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    className="text-gray-600 dark:text-gray-300 focus:outline-none"
                >
                    {isSidebarOpen ? <XIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
                </button>
                <h1 className="text-xl font-semibold text-gray-800 dark:text-white">
                    {viewTitles[currentView]}
                </h1>
            </div>
            <div className="flex items-center">
                <UserMenu onNavigate={onNavigate} />
            </div>
        </header>
    );
};
